module.exports = __webpack_public_path__ + "img/journal.cbaf8296.svg";